import { render, staticRenderFns } from "./bill_graph.vue?vue&type=template&id=1b340a37&scoped=true&"
import script from "./bill_graph.vue?vue&type=script&lang=js&"
export * from "./bill_graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b340a37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b340a37')) {
      api.createRecord('1b340a37', component.options)
    } else {
      api.reload('1b340a37', component.options)
    }
    module.hot.accept("./bill_graph.vue?vue&type=template&id=1b340a37&scoped=true&", function () {
      api.rerender('1b340a37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/profile/tabs/billing_components/bill_graph.vue"
export default component.exports